import React from 'react'
import Icon from '../../../../atoms/Icon'

function DeprecatedTag () {
  return (
    <div
      className='flex gap-sm radius-sm'
      style={{
        borderColor: 'var(--color-ai-700)',
        borderWidth: '1px',
        borderStyle: 'solid',
        padding: 'var(--padding-xs) var(--padding-sm)',
        backgroundColor: 'var(--color-warning-500)',
        color: 'var(--color-contrast-warning-500)'
      }}
    >
      <Icon name='warning' style={{ stroke: 'var(--color-warning-500)' }} />
      <span>Deprecated</span>
    </div>
  )
}

export default DeprecatedTag
